import { type ReactElement, useEffect, useState } from 'react';

import { getSignalRConnector } from '@/api/signalR/SignalRConnector.ts';
import { SessionEndedModal } from '@/components/fatality/SessionEndedModal.tsx';

export function ReceiveForceLogOffModal(): ReactElement | null {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  function onForceLogOff() {
    setIsShowModal(true);
  }

  useEffect(() => {
    const signalRConnector = getSignalRConnector();
    signalRConnector.on('ReceiveForceLogOff', onForceLogOff);

    return () => {
      signalRConnector.off('ReceiveForceLogOff', onForceLogOff);
    };
  });

  return !isShowModal ? null : <SessionEndedModal />;
}
